import { FC, useEffect } from 'react';

import { useWsClient } from '@/processes/WsService';
import { wsService } from '@/processes/WsService/model';
import { Outlet } from 'react-router';

import { useAccountsController } from '@/features/account-select/model';

import { useDefaultCountryController } from '@/entities/country';
import { useCurrenciesController } from '@/entities/currency';
import { useStaticDataController } from '@/entities/static-data';
import { usePersonalController, usePersonalStore } from '@/entities/user';

import { useViewportStore } from '@/shared/lib';
import { PageLoader } from '@/shared/ui';

export const RouteGuardProvider: FC = () => {
  const setViewport = useViewportStore((state) => state.setViewport);
  const user = usePersonalStore((state) => state.user);
  const isLoading = usePersonalController();
  const isPending = useCurrenciesController();

  useDefaultCountryController();
  const isLoadingData = useStaticDataController();
  const isLoadingAccs = useAccountsController();

  useEffect(() => {
    setViewport(window.innerWidth);

    let timeoutId: ReturnType<typeof setTimeout> | null = null;
    let lastWidth: number | null = null;
    let isThrottled = false;

    const handleResize = () => {
      const currentWidth = window.innerWidth;
      lastWidth = currentWidth;

      if (isThrottled) {
        return;
      }

      setViewport(currentWidth);
      isThrottled = true;

      timeoutId = setTimeout(() => {
        isThrottled = false;
        if (lastWidth !== null && lastWidth !== currentWidth) {
          setViewport(lastWidth);
        }
      }, 150);
    };

    window.addEventListener('resize', handleResize, { passive: true });

    return () => {
      window.removeEventListener('resize', handleResize);
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [setViewport]);

  useEffect(() => {
    if (user) {
      wsService.disconnect();
      wsService.initSockets();
    } else {
      wsService.disconnect();
    }
  }, [user]);

  useWsClient();

  //TODO: loading initial data
  if (isLoading || isLoadingAccs || isLoadingData || isPending)
    return <PageLoader />;

  return <Outlet />;
};
